export interface GetAddressByBatchParams {
  batch: string
}

export interface GetBatchDetailParams{
  batch: string
  address: string
}

export interface GetAddressDetailParams{
  address: string
  product: string
}

export interface GetProductBatchDetailParams{
  barcode: string
  address: string
}

export interface Address {
  addressFormated: string
  bin: string
  directShelf?: boolean
  dueDate?: string
  fc: number
  idAddress: number
  idStockBatchDue: number
  quantity: number
  shelf: string
  street: string
  warehouse: string
}

export interface BatchInfo {
  addresses: Address[]
  idBatch: number
  idModel: number
  productCode: string
  productDescription: string
}

export interface ProductBatchInfo {
  addresses: Address[]
  idModel: number
  productCode: string
  productDescription: string
  barcode: string
}

export interface BasicQueryState {
  batchInfo?: BatchInfo
  batchDetails?: BatchAndStockBatchDue[]
  productInfo?: ProductBatchInfo
  productDetail?: BatchAndStockBatchDue[]
  addressInfo?: {productList: AddressInfo[], address: string}
  addressDetails?: BatchAndStockBatchDue[]
}

export enum GenericApiErrors {
  Failed,
}

export interface BatchDetail {
  address: Address
  addressDetail?: string
  addressTag: AddressTag
  codProduto: string
  codigoDeBarrasUtilizado?: string
  dataFimFracionamento?: Date
  dataInclusao: Date
  dataInicioFracionamento?: Date
  dataValidade: string
  descricao: string
  descricaoPersonalizada?: string
  diretoGondola: boolean
  dtCancelado?: Date
  fc: Fc
  idLocalizacaoDestino: number
  idLote: number
  idModelo: number
  idModelo_verificado: boolean
  idRecebimento: number
  idStatuslote: number
  idUnidademedidarecebimento: number
  idUsrCancelado?: number
  measureUnit: MeasureUnit
  observacao?: string
  quantidadeAvaria: number
  quantidadeRejeitada?: number
  quantidadeTotal: number
  quantidadeTotal_original?: number
  quantidadeUtil?: number
  temperaturaItem?: number
  tipoAvaria: string
}

export interface BatchAndStockBatchDue {
  batch: BatchDetail
  stockBatchDue: StockBatchDue
}

export interface StockBatchDue {
  dataValidade: string
  dtAuditAlteracao: Date
  dtAuditInclusao: Date
  idEstoque: number
  idEstoqueValidade: number
  idLoteRecebimento: number
  idModelo: number
  quantidade: number
}

export interface AddressTag {
  rua: string
}

export interface Fc {
  name: string
}

export interface MeasureUnit {
  isKg: boolean
}

export interface Product {
  codBarras: string
  codProduto: string
  descProduto: string
  enderecoEscaninho?: string
  enderecoEstante?: string
  enderecoPiso?: string
  enderecoRua?: string
  idCategoria?: number
  idModelo: number
  idUnidademedidaRecebimento: number
  nmFabricante: string;
}

export interface AddressInfo {
  product: Product
  quantity: number
}

export interface AddressList {
  direct: Address[]
  other: Address[]
}
